import {Trans} from "@lingui/react/macro";
import {useState} from "react";
import {Link} from "react-router-dom";
import AddGroupForm from "../../features/group/AddGroupForm";
import type {GroupPreviewEntry, UserRepo} from "../../models/UserRepo";
import {StorageKey, storageWrapper} from "../../storage";
import {greenTheme} from "../../styles/themes/color-themes.css";
import {Box, Col, css, Text} from "../../ui/Box";
import Button from "../../ui/Button";

const GroupLink = ({group, active}: {group: GroupPreviewEntry; active: boolean}) => (
  <Link
    to={`/g/${group.shortId}`}
    className={css(
      {
        display: "flex",
        sp: "12",
        align: "baseline",
        rounded: "4",
        bg: "surface",
        pa: "16",
      },
      active && greenTheme
    )}
  >
    <Box color="primary" textTransform="uppercase" size="16" bold>
      {group.name}
    </Box>
    <Text color="secondary" size="14_tight" ml="auto" flex="none">
      {group.joinedAt.toDateString()}
    </Text>
  </Link>
);

const GroupFormToggle = ({userRepo}: {userRepo: UserRepo}) => {
  const [show, setShow] = useState(false);
  return (
    <Col sp="8">
      <Button variant="tertiary" onClick={() => setShow(!show)}>
        {show ? <Trans>Close</Trans> : <Trans>Create New Group</Trans>}
      </Button>

      {show && (
        <Col sp="16" pa="16" borderWidth={1} borderColor="default" rounded="4">
          <AddGroupForm userRepo={userRepo} />
        </Col>
      )}
    </Col>
  );
};

const GroupList = ({userRepo}: {userRepo: UserRepo}) => {
  const allGroups = userRepo.Group.useGetAll();
  const activeGroupId = storageWrapper.storageGet(StorageKey.LAST_GROUP_ID);
  return (
    <Col sp="8">
      {Object.values(allGroups).map((group) => (
        <GroupLink key={group.id} group={group} active={activeGroupId === group.id} />
      ))}
      <GroupFormToggle userRepo={userRepo} />
    </Col>
  );
};

const MainMenu = ({userRepo}: {userRepo: UserRepo}) => {
  return (
    <Col sp="32" flex="auto">
      <GroupList userRepo={userRepo} />
      <Col mt="auto" sp="12">
        <Button to="/profile">
          <Trans id="nav.profile">Profile</Trans>
        </Button>
        <Box size="12" color="secondary" style={{opacity: 0.25}} textAlign="center">
          {__APP_VERSION__}
        </Box>
      </Col>
    </Col>
  );
};

export default MainMenu;
